module.exports = __webpack_public_path__ + "img/s2.02584e8e.jpg";